<template>
<b-container fluid class="container">
  <div>
          <b-overlay :show="show" opacity="0.97" variant="light" spinner-type="grow" rounded="sm" style="max-width: 320px; color: #DD3E23">
            <div v-if="this.images == true" class="mt-1">
                  <img :src="this.photos" class="img-fluid mt-3 mb-3" width="300px" height="310px" alt="" />
            </div>
            <div v-if="this.images == false" class="mt-1">
                    <img src="../assets/body-icon.png" class="img-fluid mt-3 mb-3" width="300px" height="310px" alt="" />
            </div>
            <div v-for="auto in autos" :key="auto.id" class="mb-3">

                <h1 style="font-size: 15px; color: black">
                  {{ auto.modelYear }} {{ auto.brandDescription }}
                  {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }},
                  {{ auto.doors}} PUERTAS 
                </h1>
            </div>
          </b-overlay>
  </div>
</b-container>
</template>

<script>

export default {
  name: 'Descripcion',

    data() {
    return {
      vin: '',
      type: '',
      images: false,
      show: true,
      contents: null,
      autos: [],
      photos: '',
      operaciones: false,
      entrada: true

      };
  },

  methods: {
    tokenStock(){
      let user = {
      username: "desarrolloti@autocom.mx",
      password: "Autocom2021"};

      //axios.post("https://pruebas.autocomcube.mx/api/token/login", user)
      axios.post("https://autocomcube.mx/api/token/login", user) //PRO
      .then((response) => {
        this.contents = response.data.token;
              if(this.contents != null){
                 sessionStorage.setItem("tokenStock", response.data.token);
                 this.cargarInfoVehiculo();
              }
        }).catch(error => {
          console.log(error);
        });
    },
     cargarInfoVehiculo(){
       this.vin =  sessionStorage.getItem("vin");
       this.type = sessionStorage.getItem("type");
       this.token = sessionStorage.getItem("tokenStock");
       if( this.type == 'U'){
           // console.log('Seminuevo');
               //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
               axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
               headers: {
                 Authorization: "Bearer " + this.token,
                 'Content-Type': 'application/json',
               },
               params: {vin: this.vin,},
             })
             .then((response) => {
                   this.estatusU = response.data.usedstock.length;
                    if( this.estatusU > 0){
                    this.show = false;
                    this.images = true;
                    this.photos = response.data.usedstock[0].spincarphotos.photos[0].url;
                    this.autos = response.data.usedstock;
                    }
             }).catch(error => {
           console.log(error);
         });
        } else if( this.type == 'N'){
               //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
               axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
               headers: {
                 Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                 'Content-Type': 'application/json',
               },
               params: {vin: this.vin,},
             })
             .then((response) => {
                   this.estatusU = response.data.newstock.length;
                   if( this.estatusU > 0){
                      this.show = false;
                      this.autos = response.data.newstock;
                      this.photos = response.data.newstock[0].photos.photos_;
                    }
             }).catch(error => {
           console.log(error);
         });
       }
     },


    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

  },
  
  created() {
    this.tokenStock();
  }
}
</script>

<style scoped>


</style>